// removed by extract-text-webpack-plugin
module.exports = {"roles":"tyFiExitxBGVgRDRIZCiR","list":"_3SK8IqVAgSpJFvua9vM8Ie"};


//////////////////
// WEBPACK FOOTER
// ./src/Root/pages/Groups/GroupPage/Roles/style/Roles.pcss
// module id = 1410
// module chunks = 0